// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1921":"7cd2e3e05ed005bb","2888":"f6fe9eb2a78551ca","7482":"7cd2e3e05ed005bb"}[chunkId] + ".css";
};